import Link from "next/link"
import "./footer.css"
import { formatString } from "../../../src/lib/utils";

class Footer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      menuItems: [
        { name: "Who We Are", path: "/who-we-are" },
        { name: "Our Approach", path: "/who-we-partner-with" },
        { name: "Our Partners", path: "/our-partners" },
        { name: "Contact Us", path: "/contact-us" },
      ],
    }
  }
  CreateFooterMenu(currentPage) {
    return this.state.menuItems.map((item, index) => {
      return (
        <li className={currentPage == item.path ? "current" : null} key={index}>
          <Link href={item.path}>
            <a hrefLang="en">{item.name}</a>
          </Link>
        </li>
      )
    })
  }
  footerStyleClass = () => {
    if (this.props.footerPos == "relative") {
      return "relative-footer"
    }
    return ""
  }

  render() {
    let copyright = null,
      logoSrc = null
    if (this.props.data) {
      copyright = formatString(this.props.data.copyrightStatement, { year: new Date().getFullYear() });
      logoSrc = this.props.data.brightLogo
    }

    return (
      <footer className={this.footerStyleClass()}>
        <div className="container">
          <div className="inner-container">
            <div className="footer-row">
              <div className="disclaimer">{copyright}</div>
              <div className="credit">
                <a href={this.props.externalUrl} target="_blank">
                  {formatString("Photography by Stephen King ©{year}", { year: new Date().getFullYear() })}
                </a>
              </div>
              <div className="link">
                <a href="/terms-and-policies" hrefLang="en">
                  Terms & Policies
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer
